import { render, staticRenderFns } from "./actWorkClientDetailDialog.vue?vue&type=template&id=2cc73e03&"
import script from "./actWorkClientDetailDialog.vue?vue&type=script&lang=js&"
export * from "./actWorkClientDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports